import React from 'react';
import DOMPurify from 'isomorphic-dompurify';

/**
 * BioContent — renders an interpreter's "Semblanza".
 * If the stored value contains HTML (produced by the rich-text editor in the
 * admin interpreter editor) it is rendered as formatted HTML (bold, italic,
 * alignment, lists…). Legacy plain-text bios (with \n line breaks) keep their
 * line breaks via `whitespace-pre-line`. This keeps old data working while
 * enabling rich formatting going forward.
 */
function looksLikeHtml(s) {
  return /<\/?[a-z][\s\S]*>/i.test(s || '');
}

/**
 * Text pasted from PDF/Word often arrives with a non-breaking space (`&nbsp;`
 * / U+00A0) between EVERY word. Those characters prevent line wrapping, so the
 * paragraph overflows its container. We normalise them to regular spaces at
 * render time so existing bios wrap correctly without a DB migration.
 */
function normalizeSpaces(s) {
  return (s || '').replace(/&nbsp;/gi, ' ').replace(/\u00a0/g, ' ');
}

export default function BioContent({ bio, className = '', testid }) {
  if (!bio) return null;
  const clean = normalizeSpaces(bio);
  if (looksLikeHtml(clean)) {
    return (
      <div
        lang="es"
        data-testid={testid}
        className={`prose prose-charcoal max-w-none break-words text-justify [hyphens:auto] prose-p:my-2 prose-p:text-justify prose-headings:text-charcoal-800 prose-a:text-cmic-600 ${className}`}
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(clean, { ADD_ATTR: ['target', 'rel'] }) }}
      />
    );
  }
  return (
    <p lang="es" data-testid={testid} className={`whitespace-pre-line break-words text-justify [hyphens:auto] ${className}`}>{clean}</p>
  );
}
